// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.build-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.new-build {
  flex: 1;
  overflow: auto;
}

.build-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid var(--mat-sys-outline-variant);
  gap: 16px;
  flex-shrink: 0;
}

.build-title {
  display: flex;
  align-items: baseline;
  gap: 12px;
  min-width: 0;
}

.build-runid {
  font-weight: 600;
  font-size: 28px;
  opacity: 0.5;
  flex-shrink: 0;
}

.build-name {
  font-weight: 600;
  font-size: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.build-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 13px;
}

.schema-name {
  font-weight: 600;
  font-size: 15px;
}

.separator {
  color: var(--mat-sys-outline);
}

.info-item {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--mat-sys-on-surface-variant);
}
.info-item.status.running {
  color: var(--mat-sys-primary);
}
.info-item.status.complete {
  color: var(--mat-sys-primary);
}
.info-item.status.error {
  color: var(--mat-sys-error);
}
.info-item.status.cancelled {
  color: #f9a825;
}

.info-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.tags-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tags-row mat-chip-set {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.tags-row mat-chip {
  font-size: 11px;
  min-height: 24px;
}
.tags-row .tag-input {
  background: transparent;
  border: 1px dashed var(--mat-sys-outline);
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 11px;
  color: var(--mat-sys-on-surface);
  outline: none;
  width: 60px;
}
.tags-row .tag-input:focus {
  border-color: var(--mat-sys-primary);
  width: 100px;
}
.tags-row .tag-input::placeholder {
  color: var(--mat-sys-outline);
}

.build-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  margin-top: 5px;
}
.build-actions button mat-icon {
  margin-right: 4px;
}

.build-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  padding-top: 16px;
}

.schema-section {
  padding: 0 16px;
  flex-shrink: 0;
  border-bottom: 1px solid var(--mat-sys-outline-variant);
}
.schema-section ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
.schema-section.new-build-form {
  border-bottom: none;
  flex: 1;
  overflow: auto;
  padding-bottom: 16px;
}

.new-build-content {
  overflow: auto;
}

.error-alert {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  margin: 12px 16px;
  background: rgba(244, 67, 54, 0.15);
  border: 1px solid #f44336;
  border-radius: 8px;
  flex-shrink: 0;
}
.error-alert mat-icon {
  color: #f44336;
  flex-shrink: 0;
}
.error-alert span {
  flex: 1;
  font-size: 13px;
}

.processes-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  padding: 0 16px;
  margin-bottom: 8px;
}

.processes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.processes-header .section-title {
  font-size: 13px;
  font-weight: 500;
}
.processes-header mat-button-toggle-group {
  border: none;
  height: 28px;
}
.processes-header mat-button-toggle-group ::ng-deep .mat-button-toggle-label-content {
  line-height: 28px;
  padding: 0 10px;
  font-size: 11px;
}

.processes-table-container {
  flex: 1;
  overflow: auto;
  border: 1px solid var(--mat-sys-outline-variant);
  border-radius: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(128, 128, 128, 0.5) rgba(128, 128, 128, 0.1);
}
.processes-table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.processes-table-container::-webkit-scrollbar-track {
  background: rgba(128, 128, 128, 0.1);
}
.processes-table-container::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.5);
  border-radius: 4px;
}
.processes-table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(128, 128, 128, 0.7);
}

table {
  width: 100%;
}

.mat-mdc-header-row,
.mat-mdc-row {
  height: 36px !important;
}

.mat-mdc-header-cell,
.mat-mdc-cell {
  font-size: 12px;
  padding: 0 12px !important;
}

.mat-column-status {
  width: 40px;
  padding-left: 12px !important;
  padding-right: 0 !important;
}

tr.mat-mdc-row.clickable {
  cursor: pointer;
}
tr.mat-mdc-row.clickable:hover {
  background: var(--mat-sys-surface-container-highest);
}
tr.mat-mdc-row.running {
  background: color-mix(in srgb, var(--mat-sys-primary) 5%, transparent);
}

.status-running {
  color: var(--mat-sys-primary);
}

.status-complete {
  color: var(--mat-sys-primary);
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.spinning {
  animation: spin 1.5s linear infinite;
}

.no-processes {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: var(--mat-sys-outline);
}
.no-processes mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 8px;
}

.updating-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: white;
  z-index: 100;
}`, "",{"version":3,"sources":["webpack://./src/app/components/data/build/build.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAGA;EACE,OAAA;EACA,cAAA;AAAF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uDAAA;EACA,SAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,YAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wCAAA;AADF;AAII;EACE,6BAAA;AAFN;AAII;EACE,6BAAA;AAFN;AAII;EACE,2BAAA;AAFN;AAII;EACE,cAAA;AAFN;;AAOA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAJF;AAME;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAJJ;AAOE;EACE,eAAA;EACA,gBAAA;AALJ;AAQE;EACE,uBAAA;EACA,yCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,aAAA;EACA,WAAA;AANJ;AAQI;EACE,oCAAA;EACA,YAAA;AANN;AASI;EACE,6BAAA;AAPN;;AAYA;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AATF;AAYI;EACE,iBAAA;AAVN;;AAgBA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AAbF;;AAiBA;EACE,eAAA;EACA,cAAA;EACA,uDAAA;AAdF;AAiBE;EACE,wBAAA;AAfJ;AAmBE;EACE,mBAAA;EACA,OAAA;EACA,cAAA;EACA,oBAAA;AAjBJ;;AAsBA;EACE,cAAA;AAnBF;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,mCAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AApBF;AAsBE;EACE,cAAA;EACA,cAAA;AApBJ;AAuBE;EACE,OAAA;EACA,eAAA;AArBJ;;AA0BA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAvBF;AAyBE;EACE,eAAA;EACA,gBAAA;AAvBJ;AA2BE;EACE,YAAA;EACA,YAAA;AAzBJ;AA2BI;EACE,iBAAA;EACA,eAAA;EACA,eAAA;AAzBN;;AA8BA;EACE,OAAA;EACA,cAAA;EACA,gDAAA;EACA,kBAAA;EAsBA,qBAAA;EACA,kEAAA;AAhDF;AA4BE;EACE,UAAA;EACA,WAAA;AA1BJ;AA6BE;EACE,oCAAA;AA3BJ;AA8BE;EACE,oCAAA;EACA,kBAAA;AA5BJ;AA8BI;EACE,oCAAA;AA5BN;;AAqCA;EACE,WAAA;AAlCF;;AAsCA;;EAEE,uBAAA;AAnCF;;AAsCA;;EAEE,eAAA;EACA,0BAAA;AAnCF;;AAuCA;EACE,WAAA;EACA,6BAAA;EACA,2BAAA;AApCF;;AAyCE;EACE,eAAA;AAtCJ;AAwCI;EACE,oDAAA;AAtCN;AA0CE;EACE,sEAAA;AAxCJ;;AA6CA;EACE,6BAAA;AA1CF;;AA6CA;EACE,6BAAA;AA1CF;;AA8CA;EACE;IACE,uBAAA;EA3CF;EA6CA;IACE,yBAAA;EA3CF;AACF;AA8CA;EACE,oCAAA;AA5CF;;AAgDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,6BAAA;AA7CF;AA+CE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA7CJ;;AAkDA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;AA/CF","sourcesContent":[".build-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n// New build mode - schema takes full space\n.new-build {\n  flex: 1;\n  overflow: auto;\n}\n\n// Compact header with build info\n.build-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--mat-sys-outline-variant);\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n.build-title {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  min-width: 0;\n}\n\n.build-runid {\n  font-weight: 600;\n  font-size: 28px;\n  opacity: 0.5;\n  flex-shrink: 0;\n}\n\n.build-name {\n  font-weight: 600;\n  font-size: 28px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.build-info {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.info-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  font-size: 13px;\n}\n\n.schema-name {\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.separator {\n  color: var(--mat-sys-outline);\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--mat-sys-on-surface-variant);\n\n  &.status {\n    &.running {\n      color: var(--mat-sys-primary);\n    }\n    &.complete {\n      color: var(--mat-sys-primary);\n    }\n    &.error {\n      color: var(--mat-sys-error);\n    }\n    &.cancelled {\n      color: #f9a825;\n    }\n  }\n}\n\n.info-icon {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.tags-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  mat-chip-set {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n\n  mat-chip {\n    font-size: 11px;\n    min-height: 24px;\n  }\n\n  .tag-input {\n    background: transparent;\n    border: 1px dashed var(--mat-sys-outline);\n    border-radius: 16px;\n    padding: 4px 12px;\n    font-size: 11px;\n    color: var(--mat-sys-on-surface);\n    outline: none;\n    width: 60px;\n\n    &:focus {\n      border-color: var(--mat-sys-primary);\n      width: 100px;\n    }\n\n    &::placeholder {\n      color: var(--mat-sys-outline);\n    }\n  }\n}\n\n.build-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n  margin-top: 5px;\n\n  button {\n    mat-icon {\n      margin-right: 4px;\n    }\n  }\n}\n\n// Content area - flex column, no scroll on this container\n.build-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n  padding-top: 16px;\n}\n\n// Schema section (inline) - stays fixed at top\n.schema-section {\n  padding: 0 16px;\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--mat-sys-outline-variant);\n\n  // Hide form field subscript wrapper (hints/errors space)\n  ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n    display: none !important;\n  }\n\n  // New build form - no border, allow scrolling\n  &.new-build-form {\n    border-bottom: none;\n    flex: 1;\n    overflow: auto;\n    padding-bottom: 16px;\n  }\n}\n\n// New build content area - scrollable\n.new-build-content {\n  overflow: auto;\n}\n\n// Error alert banner\n.error-alert {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  margin: 12px 16px;\n  background: rgba(244, 67, 54, 0.15);\n  border: 1px solid #f44336;\n  border-radius: 8px;\n  flex-shrink: 0;\n\n  mat-icon {\n    color: #f44336;\n    flex-shrink: 0;\n  }\n\n  span {\n    flex: 1;\n    font-size: 13px;\n  }\n}\n\n// Processes section - fills remaining space\n.processes-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0 16px;\n  margin-bottom: 8px;\n}\n\n.processes-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  flex-shrink: 0;\n\n  .section-title {\n    font-size: 13px;\n    font-weight: 500;\n  }\n\n  // Compact filter toggles\n  mat-button-toggle-group {\n    border: none;\n    height: 28px;\n\n    ::ng-deep .mat-button-toggle-label-content {\n      line-height: 28px;\n      padding: 0 10px;\n      font-size: 11px;\n    }\n  }\n}\n\n.processes-table-container {\n  flex: 1;\n  overflow: auto;\n  border: 1px solid var(--mat-sys-outline-variant);\n  border-radius: 8px;\n\n  // Scrollbar styling\n  &::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(128, 128, 128, 0.1);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(128, 128, 128, 0.5);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(128, 128, 128, 0.7);\n    }\n  }\n\n  // Firefox\n  scrollbar-width: thin;\n  scrollbar-color: rgba(128, 128, 128, 0.5) rgba(128, 128, 128, 0.1);\n}\n\ntable {\n  width: 100%;\n}\n\n// Compact rows\n.mat-mdc-header-row,\n.mat-mdc-row {\n  height: 36px !important;\n}\n\n.mat-mdc-header-cell,\n.mat-mdc-cell {\n  font-size: 12px;\n  padding: 0 12px !important;\n}\n\n// Status column narrow\n.mat-column-status {\n  width: 40px;\n  padding-left: 12px !important;\n  padding-right: 0 !important;\n}\n\n// Process row states\ntr.mat-mdc-row {\n  &.clickable {\n    cursor: pointer;\n\n    &:hover {\n      background: var(--mat-sys-surface-container-highest);\n    }\n  }\n\n  &.running {\n    background: color-mix(in srgb, var(--mat-sys-primary) 5%, transparent);\n  }\n}\n\n// Status icons\n.status-running {\n  color: var(--mat-sys-primary);\n}\n\n.status-complete {\n  color: var(--mat-sys-primary);\n}\n\n// Spinning animation for running processes\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spinning {\n  animation: spin 1.5s linear infinite;\n}\n\n// Empty state\n.no-processes {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n  color: var(--mat-sys-outline);\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    margin-bottom: 8px;\n  }\n}\n\n// Updating overlay\n.updating-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  color: white;\n  z-index: 100;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
